import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; 
import "../Components/UserSignIn/SignIn.css";
import {
  LOGIN_SUCCESS,
} from "../Constants/userConstants.js";
import { useDispatch } from "react-redux";


const UserSignIn = () => {
  const [formState, setFormState] = useState({
    email: '',
    password: '',
  });
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false); // New state for error
  const messageRef = useRef(null); // Ref to access the message element
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post('/api/v1/users/login', formState);

      // Handle successful login
      console.log('Login successful:', response.data);
      setMessage('Login successful');
      setIsError(false); // Reset error state

      // const { twoFac } = response.data.user.preferences;
  
      if (response.data.twoFa) {
      // if (twoFac){
        // Redirect to the OTP verification page
        navigate(`/otp-verification/${response.data.userId}`);
      } else {
        if (response.data.user){
          dispatch({ type: LOGIN_SUCCESS, payload: response.data.user });
          navigate('/');
        } else {
          setMessage("Login Error");
        }
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setMessage(error.response.data.message || 'An error occurred');
        setIsError(true); // Set error state
      } else {
        setMessage('An error occurred');
        setIsError(true); // Set error state
      }
      console.error('Login error:', error);

      // Re-trigger the animation
      if (messageRef.current) {
        messageRef.current.classList.remove('flash-shake');
        void messageRef.current.offsetWidth;
        messageRef.current.classList.add('flash-shake');
      }
    }
  };

  return (
    <div className="sign-in">
      <h1>Welcome</h1>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email:</label>
          <input
            id="emailSignIn"
            type="email"
            name="email"
            value={formState.email}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Password:</label>
          <input
            id="passwordSignIn"
            type="password"
            name="password"
            value={formState.password}
            onChange={handleChange}
          />
        </div>

        {message && (
          <div ref={messageRef} className={`message ${isError ? 'flash-shake' : ''}`}>
            {message}
          </div>
        )}  {}
        
        <div className="forgot-password">
          <a href="/password/forgot">Forgot Password?</a>
        </div>

        <button className="login-button" type="submit">Login</button>

        <div className="register-link">
          <a href="/register">Don't have an account? Register</a>
        </div>

      </form>
    </div>
  );
};
export default UserSignIn;
